import React from "react";
import { errorDev } from "../utils/logger";

export default class GlobalErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    errorDev("[GlobalErrorBoundary]", error, errorInfo);
  }

  handleRetry = () => {
    this.setState({ hasError: false });
    if (typeof window !== "undefined") {
      window.location.reload();
    }
  };

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <div className="min-h-screen flex items-center justify-center px-6 bg-background text-foreground">
        <div className="max-w-lg w-full rounded-2xl border border-border bg-card shadow-sm p-7 text-center">
          <h1 className="text-2xl font-bold text-primary">It&apos;s Orrith, not you.</h1>
          <p className="mt-3 text-sm text-muted-foreground">
            Something unexpected happened. Your data is safe, and you can retry now.
          </p>
          <div className="mt-6">
            <button
              type="button"
              onClick={this.handleRetry}
              className="px-4 py-2 rounded-lg bg-green-700 text-white text-sm font-semibold hover:bg-green-800"
            >
              Retry
            </button>
          </div>
        </div>
      </div>
    );
  }
}
